import { gql } from '@apollo/client';

export const GET_BOOKMARKED_QUESTIONS_FOR_USER = gql(/*GraphQL*/ `
query GetBookmarkedQuestionsForUser {
  getBookmarkedQuestionsForUser {
    explanation
    id
    options {
      desc
      isAnswer
    }
    prompt
    tag
    label
  }
}
`);
